export const CONFIG = {
    API_URL: process.env.API,
    ID_AUCTION_DOING: "1",
    ID_AUCTION_DO: "0",
    ID_AUCTION_DONE: "2",
}
export default CONFIG;



// WEBPACK FOOTER //
// ./src/common/config.js